import { TIME_PERIOD } from './filters.constants';

export const TIME_PERIOD_FILTERS = [TIME_PERIOD.DAY, TIME_PERIOD.WEEK, TIME_PERIOD.MONTH, TIME_PERIOD.YEAR];

export const TIME_PERIOD_FILTERS_WITH_CUSTOM_PERIOD = [...TIME_PERIOD_FILTERS, TIME_PERIOD.CUSTOM];
